(() => {
  if (window.__vccWishlistCountBootstrapReady) return;
  window.__vccWishlistCountBootstrapReady = true;

  const context = window.VCCWishlistContext || {};
  const storeKey = context.storeKey || 'vccWishlistStoreV2';
  const legacyKey = context.legacyKey || 'vccWishlist';
  const owner = context.customerId ? `customer:${String(context.customerId)}` : 'guest';

  function readJson(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || 'null');
    } catch (_error) {
      return null;
    }
  }

  function countFromStorage() {
    const store = readJson(storeKey);
    const owned = store?.owners?.[owner];
    if (Array.isArray(owned)) return owned.length;

    const legacy = readJson(legacyKey);
    return Array.isArray(legacy) ? legacy.length : 0;
  }

  function sync(count = countFromStorage(), scope = document) {
    const safeCount = Math.max(0, Number(count) || 0);
    const root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    root.querySelectorAll('[data-vcc-wishlist-count]').forEach((badge) => {
      badge.textContent = String(safeCount);
      badge.hidden = safeCount === 0;
    });

    root.querySelectorAll('[data-vcc-wishlist-link]').forEach((link) => {
      link.setAttribute(
        'aria-label',
        safeCount
          ? `Wishlist (${safeCount} saved ${safeCount === 1 ? 'piece' : 'pieces'})`
          : 'Wishlist'
      );
    });

    return safeCount;
  }

  function ready() {
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  window.addEventListener('pageshow', () => sync());
  window.addEventListener('storage', (event) => {
    if (event.key === storeKey || event.key === legacyKey) sync();
  });
  document.addEventListener('vcc:wishlist:updated', (event) => {
    sync(event.detail?.count);
  });
  document.addEventListener('shopify:section:load', (event) => {
    sync(undefined, event.target || document);
  });

  window.VCCWishlistCountBootstrap = Object.freeze({ sync, countFromStorage });
})();
